import { MraidUnloadCallHandler } from 'common/stores/handlers/MraidUnloadCallHandler';

export class MraidNoUnloadOnClickHandler extends MraidUnloadCallHandler {
  protected onUserClicked() {}
}
